import { getApiUrl } from '../../Url';

export async function fetchPartnerIds(
  userId: number
): Promise<{ optimizely: string; mParticle?: string }> {
  const urlPath = getApiUrl({ path: `${userId}/partnerIds` });

  try {
    const response = await fetch(urlPath, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({ userId }),
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error(`Could not fetch Partner Ids`);
  } catch (err) {
    throw new Error(err.message);
  }
}
